import React from 'react';
import './Footer.scss';

const Footer: React.FunctionComponent<{}> = React.memo(() => {
    return (
        <footer className="FooterContainer">
            <div className="container">
                <p className="email"><a href="mailto:info@linea2000sa.com.ar">info@linea2000sa.com.ar</a></p>
                <p>(+54) 261 40-58308 | 155 91-5911</p>
                <div className="text-center">
                    <img 
                        ui-sref="home"
                        alt="Linea2000 distribuidor"
                        src="./assets/logo_footer.png" />
                </div>
            </div>
            <div className="last-footer">
                <div className="container">
                    <div className="copyright pull-left">Copyright | 2020 Todos los derechos reservados.</div>
                    <div className="powered pull-right">
                        <a rel="noopener noreferrer" href="http://huskysoft.com/" target="_blank">Powered by <img alt="Husky software" src='./assets/husky_logo.png' /></a>
                    </div>
                </div>
            </div>
        </footer>
    );
});

export default Footer;
